import { URLS } from "@/constants/urls";

export interface IPrescriptionFileResponse {
  prescriptionFile: string; // img file encoded in base64
}

export const downloadPrescriptionFile = async (
  storeId: string,
  fileName: string,
  basePath: string = window.location.origin,
): Promise<IPrescriptionFileResponse> => {
  return new Promise((resolve, reject) => {
    const downloadFileUrl = (basePath + URLS.DOWNLOAD_PRESCRIPTION_FILE)
      .replace("{storeId}", storeId)
      .replace("{fileName}", fileName)
      .replace("{noCache}", new Date().getTime().toString());

    fetch(downloadFileUrl, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) {
          reject(response);
          return;
        }
        return response.json();
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
